import { SwiperContainer } from '@/components/containers/swiper-container';
import { CdnImg } from '@/features/cdn-img';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { convertApiLocale } from '@nf/utils-common/site';
import { useLocale } from 'next-intl';
import { useState } from 'react';
import { css } from 'styled-system/css';

export const LoginBanner = () => {
	const { SiteConfigsData: siteConfigData } = useGetSiteConfigs();
	const supportLanguages = useSupportLanguages();
	const currentLocale = useLocale();
  
	const siteId = siteConfigData?.GetMessageID?.substring(0, 5);
	const currentLanguage = supportLanguages?.find((lang) => lang.value === convertApiLocale(currentLocale));
  
	const imgPathList = siteId && currentLanguage 
		? siteData[siteId]?.getPathList(siteId, currentLanguage.ShortCode) 
		: [];
    
	// 若圖片沒有自動拿取en的
	const fallbackImgPathList = siteId
		? siteData[siteId]?.getPathList(siteId, 'en') 
		: [];
  
	return (
		<div>
			<SwiperContainer
				slideElements={
					imgPathList?.map((path, index) => (
						<ImageWithFallback 
							key={index} 
							src={path} 
							fallbackSrc={fallbackImgPathList[index]} 
						/>
					))
				}
				customProps={{
					navigation: { enabled: imgPathList.length <= 1 },
					pagination: { enabled: true },
					allowTouchMove: true,
					spaceBetween: 6,
					loop: true,
					autoplay: {
						delay: 2500,
						disableOnInteraction: false
					},
				}}
			/>
		</div>
	);
};

const ImageWithFallback = ({ fallbackSrc, ...props }: React.ComponentPropsWithoutRef<'img'> & { fallbackSrc: string }) => {
	const [imgSrc, setImgSrc] = useState(props.src);

	const handleError = () => {
		setImgSrc(fallbackSrc);
	};
	return imgSrc ? (
		<CdnImg
			className={css({
				w: '100%'
			})}
			{...props}
			src={imgSrc}
			onError={handleError}
			
		/>
	): null
}

const siteData: { [key in string]: { getPathList: (siteId: string, locale: string) => string[] } } = {
	'42026': {
		getPathList: (siteId, locale) => [
			`/images/jupiter/${siteId}/banners/${locale}/download-app.jpg`,
			`/images/jupiter/global/login-banner/${locale}/pm_cricket_aio.jpg`
		]
	},
	// Macaubet
	'42018': {
		getPathList: (siteId, locale) => [
			`/images/jupiter/${siteId}/banners/${locale}/pm_macaubet-bonus-turnover.jpg`,
			`/images/jupiter/${siteId}/banners/${locale}/download-app.jpg`,
			`/images/jupiter/global/login-banner/${locale}/pm_cricket_aio.jpg`
		]
	},
	// Aoncash
	'42021': {
		getPathList: (siteId, locale) => [
			`/images/jupiter/${siteId}/banners/${locale}/download-app.jpg`,
			`/images/jupiter/global/login-banner/${locale}/pm_cricket_aio.jpg`
		]
	},
	// ITCBet
	'42024': {
		getPathList: (siteId, locale) => [
			`/images/jupiter/${siteId}/banners/global/2.png`,
			`/images/jupiter/${siteId}/banners/global/3.png`,
			`/images/jupiter/${siteId}/banners/global/4.png`,
			`/images/jupiter/${siteId}/banners/global/5.png`,
			`/images/jupiter/${siteId}/banners/global/6.png`,
			`/images/jupiter/${siteId}/banners/global/7.png`,
		]
	},
	// Bolanation
	'42156': {
		getPathList: (siteId, locale) => [
			`/images/jupiter/global/login-banner/${locale}/pm_cricket_aio.jpg`
		]
	},
	// 9bet
	'42063': {
		getPathList: (siteId, locale) => [
			`/images/jupiter/${siteId}/banners/${locale}/download-app.jpg`,
			`/images/jupiter/global/login-banner/${locale}/pm_cricket_aio.jpg`
		]
	},
	// M8Bola
	'42094': {
		getPathList: (siteId, locale) => [
			`/images/jupiter/global/login-banner/${locale}/pm_cricket_aio.jpg`
		]
	},
	// Q8bola
	'42102': {
		getPathList: (siteId, locale) => [
			`/images/jupiter/global/login-banner/${locale}/pm_cricket_aio.jpg`
		]
	},
}

const useSupportLanguages = () => {
	const { SiteConfigsData } = useGetSiteConfigs();
	return 	SiteConfigsData?.SupportLanguages?.map((language) => ({ label: language.Name, value: convertApiLocale(language.IsoCode), ShortCode: language.ShortCode }));
}
